import { gsap } from 'gsap';
import { initials, enter } from '../animations';

export function introEnter(el) {
  const content = el.querySelector('.content__text');
  const button = el.querySelector('.content__button');
  const share = el.querySelector('.content__share');
  const slider = el.querySelector('.slider');
  const cookie = el.querySelector('.cookie-bar');
  const tl = gsap.timeline();

  initials.get('fade')(content);
  initials.get('roundedButton')(button);
  initials.get('fade')(cookie);

  tl.addLabel('start')
    .add(enter.get('fade')(content), share ? 'start+=0.3' : 'start+=0.4')
    .add(enter.get('roundedButton')(button), share ? 'start+=1.3' : 'start+=0.7')
    .add(enter.get('fade')(cookie), share ? 'start+=1.5' : 'start+=1');

  if (share) {
    const table = el.querySelector('.content__table');
    const shareText = share.querySelector('.share-button__caption');
    const shareButton = share.querySelector('.share-button__button');
    initials.get('fade')(shareText);
    initials.get('circularButton')(shareButton);
    initials.get('fade')(table);

    tl.add(enter.get('fade')(shareText), 'start+=0.6')
      .add(enter.get('circularButton')(shareButton), 'start+=0.7')
      .add(enter.get('fade')(table), 'start+=1');
  }

  if (slider) {
    const captionButton = el.querySelector('.selection__button');
    initials.get('slider')(slider);
    initials.get('fade')(captionButton);

    tl.add(enter.get('slider')(slider), 'start+=0.2')
      .add(enter.get('fade')(captionButton), 'start+=0.5');
  }

  return tl;
}

export function introLeave(el) {
  const tl = gsap.timeline();

  tl.addLabel('start')
    .to(el, { opacity: 0, ease: 'bloom' });

  return tl;
}
